import { availableCountries, CountryDetail } from "Models/Enums/CountryCodeEnum";
import { useState } from "react";
import ComboboxSetter from "Views/Components/Combobox/ComboboxSetter";
import { CountrySearchBox } from "Views/Components/CountrySearchBox/CountrySearchBox";

type JurisdictionSelectionProps = {
	countryCode: string;
	updateCountryCode: (data: string, isValid: boolean) => void;
}

export const JurisdictionSelection: React.FunctionComponent<JurisdictionSelectionProps> = ({
	countryCode: value,
	updateCountryCode
}) => {
	const [tempData, setTempData] = useState<string>(!!value ? (value === "AU" || value === "NZ") ? value: "Int": "");
	const [countryDetail, setCountryDetail] = useState<CountryDetail | undefined>(tempData === "Int" ? availableCountries.find(item => item.code === value) || undefined : undefined);

	const handleTempDataChange = (data: "AU" | "NZ" | "Int") => {
		setTempData(data);
		if (data === "AU" || data === "NZ") {
			setCountryDetail(undefined);
			updateCountryCode(data, true);
			return;
		}
		updateCountryCode("", !!countryDetail?.code);
	}

	return (
		<>
			<ComboboxSetter
				value={tempData as "AU" | "NZ" | "Int"}
				setValue={(data: "AU" | "NZ" | "Int") => handleTempDataChange(data)}
				options={[
					{ value: "AU", display: "Australia" },
					{ value: "NZ", display: "New Zealand" },
					{ value: "Int", display: "International" }
				]}
				label="Select Jurisdiction"
				getOptionValue={data => data}
				placeholder="Select Jurisdiction"
			/>
			{tempData === "Int" && (
				<CountrySearchBox
					value={countryDetail}
					updateValue={(data: CountryDetail) => {
						setCountryDetail(data);
						updateCountryCode(data.code, true);
					}}
				/>
			)}
		</>
	)
}